module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "ticket-success"
  }, [_c('h2', [_vm._v("察看票卷")]), (_vm.getUser.registered.me && _vm.getUser.registered.me.status === 4) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap info-schedule col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "ticket-bg",
    class: {
      'ticket-bg--horizon': !_vm.isMobile, 'ticket-bg--straight': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "ticket-name"
  }, [_vm._v(_vm._s(_vm.getUser.payment.description))]), (_vm.getUser.registered.me.section) ? _c('div', {
    staticClass: "seat-number"
  }, [_c('div', {
    staticClass: "section"
  }, [_vm._v(_vm._s(_vm.getUser.registered.me.section) + " 區")]), _c('div', {
    staticClass: "seat"
  }, [_vm._v(_vm._s(_vm.getUser.registered.me.section) + _vm._s(_vm.getUser.registered.me.human_x) + "-" + _vm._s(_vm.getUser.registered.me.human_y))])]) : _vm._e(), (!_vm.getUser.registered.me.section) ? _c('div', {
    staticClass: "seat-number"
  }, [_c('span', [_vm._v("尚未劃位")])]) : _vm._e(), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-info-row ticket-id"
  }, [_c('div', {
    staticClass: "info-name"
  }, [_vm._v("票卷編號：")]), _c('div', {
    staticClass: "info-content"
  }, [_vm._v(_vm._s(_vm.getUser.registered.me.ticket_no))])]), _c('div', {
    staticClass: "user-info-row nickname"
  }, [_c('div', {
    staticClass: "info-name"
  }, [_vm._v("帳號：")]), _c('div', {
    staticClass: "info-content"
  }, [_vm._v(_vm._s(_vm.getUser.registered.me.gamers_account))])]), _c('div', {
    staticClass: "user-info-row user-id"
  }, [_c('div', {
    staticClass: "info-name"
  }, [_vm._v("身份證後四碼：")]), _c('div', {
    staticClass: "info-content"
  }, [_vm._v(_vm._s(_vm.getUser.registered.me.id_number))])])]), _c('div', {
    staticClass: "qr-code"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUser.registered.me.qr_code_image_url
    }
  })])])])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [(_vm.getUser.registered.me && _vm.getUser.registered.me.coupons.length > 0) ? _c('div', {
    staticClass: "coupons"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("相關優惠代碼")]), (_vm.getUser.registered.me.coupons.length > 3) ? _c('span', {
    on: {
      "click": _vm.toggleCoupon
    }
  }, [(_vm.couponSwitch === 3) ? _c('div', {
    staticClass: "btn btn-xs"
  }, [_vm._v("展開")]) : _c('div', {
    staticClass: "btn btn-xs"
  }, [_vm._v("關閉")])]) : _vm._e()]), _c('div', {
    staticClass: "coupons-wrap"
  }, [_vm._l((_vm.getUser.registered.me.coupons), function(coupon, index) {
    return (index < _vm.couponSwitch) ? _c('div', {
      staticClass: "coupon"
    }, [_c('a', {
      staticClass: "source",
      attrs: {
        "href": "https://www.elementaltotem.com/pages/wirforce",
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(coupon.source))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(coupon.type))]), _c('div', {
      staticClass: "code"
    }, [_vm._v(_vm._s(coupon.code))]), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(coupon.description))])]) : _vm._e()
  }), (_vm.getUser.registered.me.coupons.length > 3) ? _c('span', {
    on: {
      "click": _vm.openCoupon
    }
  }, [(_vm.couponSwitch === 3) ? _c('div', {
    staticClass: "btn ghost-btn"
  }, [_vm._v("全部優惠卷")]) : _vm._e()]) : _vm._e()], 2)]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap info-schedule col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("訂單資訊")]), (_vm.getUser.registered.me) ? _c('div', {
    staticClass: "content border-styled"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/submit-success-icon.png")
    }
  }), (_vm.getUser.registered.me) ? _c('span', [_vm._v(_vm._s(_vm.getUser.registered.me.status_string))]) : _vm._e(), (_vm.getUser.registered.me && _vm.getUser.registered.me.status !== 1 && _vm.getUser.registered.me.status !== 5) ? _c('div', [(_vm.getUser.payment.payments_code) ? _c('hr') : _vm._e(), (_vm.getUser.payment.payments_code) ? _c('ul', {
    staticClass: "payment-code"
  }, [_c('li', [_vm._v("繳費代碼")]), _c('li', [_vm._v(_vm._s(_vm.getUser.payment.payments_code))])]) : _vm._e(), _c('hr'), _c('ul', {
    staticClass: "payment-detail"
  }, [_c('li', [_c('span', [_vm._v("商品名稱")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.description))])]), _c('li', [_c('span', [_vm._v("訂單編號")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.order_id))])]), _c('li', [_c('span', [_vm._v("金額")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.amount))])]), (_vm.getUser.payment.expired_at) ? _c('li', [_c('span', [_vm._v("繳費期限")]), _c('span', [_vm._v(_vm._s(_vm.getUser.payment.expired_at))])]) : _vm._e()])]) : _vm._e()]) : _c('div', {
    staticClass: "content border-styled"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/submit-success-icon.png")
    }
  }), _c('span', [_vm._v("尚未購票")]), (_vm.errmsg) ? _c('span', [_vm._v(" - " + _vm._s(_vm.errmsg.type))]) : _vm._e()]), _c('div', {
    staticClass: "mb-3"
  }), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'payment'
      },
      "target": "_blank"
    }
  }, [_vm._v("代碼繳費說明")])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap col-md-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("報名資訊")]), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.getUser.registered.group), function(register) {
    return (_vm.getUser.registered.group) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "apply-info",
      class: {
        'isLeader': register.is_leader === true, 'isMe': register.is_me === true
      }
    }, [_c('div', {
      staticClass: "content border-styled ltr-block"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('ul', {
      staticClass: "title col-md-5"
    }, [(register.name) ? _c('li', [_vm._v("暱稱")]) : _vm._e(), (register.gamers_account) ? _c('li', [_vm._v("帳號")]) : _vm._e(), (register.id_number && register.id_number.length > 1) ? _c('li', [_vm._v("身分證末四碼")]) : _vm._e(), (register.email && register.email.length > 1) ? _c('li', [_vm._v(" Email")]) : _vm._e()]), _c('ul', {
      staticClass: "text col-md-7"
    }, [_c('li', [_vm._v(_vm._s(register.nickname))]), _c('li', [_vm._v(_vm._s(register.gamers_account))]), (register.id_number && register.id_number.length > 1) ? _c('li', [_vm._v(_vm._s(register.id_number))]) : _vm._e(), (register.email && register.email.length > 1) ? _c('li', [_vm._v(_vm._s(register.email))]) : _vm._e()])])])])]) : _vm._e()
  }), (!_vm.getUser.registered.me && !_vm.getUser.registered.group) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'ticketType'
      }
    }
  }, [_vm._v("前往購票")])], 1) : _vm._e()], 2)])]), _c('hr'), (_vm.getUser.seats) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-wrap col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), (!_vm.getUser.seats.chosen) ? _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(1)]) : _vm._l((_vm.getUser.seats.chosen), function(member) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "apply-info",
      class: {
        'isLeader': member.is_leader, 'isMe': member.is_me
      }
    }, [_c('div', {
      staticClass: "content border-styled ltr-block"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('ul', {
      staticClass: "title col-md-4"
    }, [_c('li', {
      staticClass: "seat-id"
    }, [_vm._v("座位")]), _c('li', [_vm._v("暱稱")]), _c('li', [_vm._v("帳號")]), (member.email && member.email.length > 1) ? _c('li', [_vm._v("Email")]) : _vm._e()]), _c('ul', {
      staticClass: "text col-md-8"
    }, [_c('li', {
      staticClass: "seat-id"
    }, [_vm._v(_vm._s(member.section) + _vm._s(member.human_seat_x) + "-" + _vm._s(member.human_seat_y))]), _c('li', [_vm._v(_vm._s(member.nickname))]), _c('li', [_vm._v(_vm._s(member.gamers_account))]), (member.email && member.email.length > 1) ? _c('li', [_vm._v(_vm._s(member.email))]) : _vm._e()])])])])])
  }), _vm._m(2), (!_vm.getUser.seats.unChosen) ? _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(3)]) : _vm._l((_vm.getUser.seats.unChosen), function(member) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "apply-info",
      class: {
        'isLeader': member.is_leader, 'isMe': member.is_me
      }
    }, [_c('div', {
      staticClass: "content border-styled ltr-block"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('ul', {
      staticClass: "title col-md-4"
    }, [_c('li', [_vm._v("暱稱")]), _c('li', [_vm._v("帳號")]), (member.email && member.email.length > 1) ? _c('li', [_vm._v("Email")]) : _vm._e()]), _c('ul', {
      staticClass: "text col-md-8"
    }, [_c('li', [_vm._v(_vm._s(member.nickname))]), _c('li', [_vm._v(_vm._s(member.gamers_account))]), (member.email && member.email.length > 1) ? _c('li', [_vm._v(_vm._s(member.email))]) : _vm._e()])])])])])
  })], 2)])]) : _vm._e(), (_vm.getUser.registered.me && _vm.getUser.registered.me.status === 4 && this.getUser.registered.me.is_leader === true) ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "btn ghost-btn",
    on: {
      "click": _vm.sendNotification
    }
  }, [_vm._v("通知團員劃位")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("已劃位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-info"
  }, [_c('div', {
    staticClass: "content border-styled ltr-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "text"
  }, [_c('li', [_vm._v("尚無人劃位")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("尚未劃位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-info"
  }, [_c('div', {
    staticClass: "content border-styled ltr-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "text"
  }, [_c('li', [_vm._v("全數劃位完成")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5c11732"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 580
// module chunks = 1